// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"3a8dd3c0","348":"b9b5e794","426":"5f55c941","911":"0f7718f8"}[chunkId] + ".chunk.css";
};